<ng-container *transloco="let t">
    <div
        *ngIf="active"
        class="sai-quick-tour"
        [class.sai-quick-tour--opening]="isOpening"
        [class.sai-quick-tour--behind-overlay]="behindOverlay"
        [class.sai-quick-tour--form-coach]="formCoachActive"
        [attr.dir]="dir"
        role="presentation"
        (keydown.escape)="onEscape($event)"
    >
        <!-- Full scrim for centered steps / intro coach beats -->
        <div
            class="sai-quick-tour__scrim"
            [class.sai-quick-tour__scrim--visible]="showFullScrim"
            aria-hidden="true"
        ></div>

        <!-- Cutout dimmer — box-shadow paints the overlay around the target -->
        <div
            *ngIf="pinnedSpotlight as spot"
            class="sai-quick-tour__cutout"
            [class.sai-quick-tour__cutout--visible]="showSpotlight"
            [style.top.px]="spot.y"
            [style.left.px]="spot.x"
            [style.width.px]="spot.width"
            [style.height.px]="spot.height"
            aria-hidden="true"
        ></div>

        <!-- Spotlight ring -->
        <div
            *ngIf="pinnedSpotlight as spot"
            class="sai-quick-tour__ring"
            [class.sai-quick-tour__ring--visible]="showSpotlight && !formCoachActive"
            [style.top.px]="spot.y - 4"
            [style.left.px]="spot.x - 4"
            [style.width.px]="spot.width + 8"
            [style.height.px]="spot.height + 8"
            aria-hidden="true"
        ></div>

        <!-- Tooltip card -->
        <div
            #tourCard
            class="sai-quick-tour__card"
            [class.sai-quick-tour__card--centered]="isCentered"
            [class.sai-quick-tour__card--mobile-dock]="isMobileDocked"
            [class.sai-quick-tour__card--mobile-anchor]="isMobileAnchored"
            [class.sai-quick-tour__card--visible]="cardVisible"
            [style.top.px]="cardPosition.top"
            [style.left.px]="cardPosition.left"
            [style.width.px]="cardWidthOverride"
            [style.max-height.px]="cardMaxHeight"
            role="dialog"
            aria-modal="true"
            [attr.aria-label]="t(titleKey)"
        >
            <div class="sai-quick-tour__card-accent" aria-hidden="true"></div>

            <div
                class="sai-quick-tour__card-content"
                [class.sai-quick-tour__card-content--visible]="contentVisible"
            >
                <div class="sai-quick-tour__card-header">
                    <div class="sai-quick-tour__step-badge" aria-hidden="true">
                        <img
                            src="assets/images/agent.png"
                            alt=""
                            class="sai-quick-tour__step-badge-img"
                            width="42"
                            height="42"
                        />
                    </div>
                    <div class="sai-quick-tour__card-heading">
                        <p class="sai-quick-tour__eyebrow">
                            {{ t(eyebrowLabel) }} · {{ stepNumber }} / {{ displayTotal }}
                        </p>
                        <h2 class="sai-quick-tour__title">{{ t(titleKey) }}</h2>
                    </div>
                    <button
                        type="button"
                        class="sai-quick-tour__close"
                        [attr.aria-label]="formCoachActive ? t('Skip guide') : t('Close tour')"
                        [attr.title]="formCoachActive ? t('Skip guide') : t('Close tour — resume later')"
                        (click)="close()"
                    >
                        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                    </button>
                </div>

                <p class="sai-quick-tour__body">{{ bodyText }}</p>
                <p class="sai-quick-tour__sample" *ngIf="formCoachSampleKey as sample">
                    <span class="sai-quick-tour__sample-label">{{ t('Sample') }}</span>
                    {{ t(sample) }}
                </p>
            </div>

            <div class="sai-quick-tour__progress" aria-hidden="true">
                <span
                    *ngFor="let dot of dots; let i = index; trackBy: trackByIndex"
                    class="sai-quick-tour__dot"
                    [class.sai-quick-tour__dot--active]="i === activeDotIndex"
                    [class.sai-quick-tour__dot--done]="i < activeDotIndex"
                ></span>
            </div>

            <div class="sai-quick-tour__actions">
                <button
                    type="button"
                    mat-button
                    class="sai-quick-tour__action-secondary"
                    [disabled]="formCoachActive ? formCoachIndex === 0 : stepIndex === 0"
                    (click)="back()"
                >
                    {{ t('Back') }}
                </button>
                <button
                    type="button"
                    mat-stroked-button
                    class="sai-quick-tour__action-secondary"
                    (click)="skip()"
                >
                    {{ formCoachActive ? t('Skip guide') : t('Skip tour') }}
                </button>
                <button
                    type="button"
                    mat-flat-button
                    class="bg-primary sai-quick-tour__action-primary"
                    (click)="primaryAction()"
                >
                    {{
                        formCoachActive
                            ? (formCoachIndex >= formCoachTotal - 1 ? t('Got it') : t('Next'))
                            : t(primaryLabelKey)
                    }}
                </button>
            </div>
        </div>
    </div>
</ng-container>
